import { isFunction } from 'lodash';
import { useCallback, useRef, useState } from 'react';

export interface ModalProps {
  open: boolean;
  customFn: () => void;
  onOpenModal: (fn?: any) => void;
  onCloseModal: () => void;
  onToggleModal: () => void;
}

export const useModal = (isOpen = false) => {
  const [open, setOpen] = useState(isOpen);
  const customFn = useRef(() => {});

  const onOpenModal = useCallback((fn?: any) => {
    if (fn && isFunction(fn)) customFn.current = fn;

    setOpen(true);
  }, []);

  const onCloseModal = useCallback(() => setOpen(false), []);

  const onToggleModal = useCallback(() => setOpen((state) => !state), []);

  return {
    open,
    customFn: customFn.current,
    onOpenModal,
    onCloseModal,
    onToggleModal,
  } as ModalProps;
};
